import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOepi = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="UTILIZAÇÃO DO EPI DURANTE A ASSISTÊNCIA" />
                    <div style={{ textAlign: "left" }}>
                        <HeaderVerde texto="Profissinal" />
                        <Select label="Máscara N95" nome="ton95" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Avental Descartável" nome="toavental" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Touca de Proteção" nome="totouca" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Propé" nome="toprope" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Protetor Facial/Óculos de Proteção" nome="tooculos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="17vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                       
                    </div>
       
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Conformidade com a Resolução COFFITO Nº 517/2020"
                            nome="conformidade517" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthDiv="60vw" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Utilização de EPI por parte do profissional em conformidade com a nota técnica 
                    ANVISA 04/2020 e nota técnica ANVISA 07/2020"
                            nome="conformidade517" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthDiv="60vw" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa>
            )
        }
        return partes
    }
}

export default TOepi